import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RichText from '~/components/common/rich-text';
import Icon from '~/components/common/icon';
import { updateQuestion } from '~/api';
import { updateQuestionType } from '~/redux/actions/workspaceActions';

/**
 * Question content (the actual question, as opposed to the question post title)
 */
class QuestionContent extends PureComponent {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		this.state = {
			content: this.props.question.post_content,
			is_loading: false,
			error: null,
		};

		this.handleQuestionContent = this.handleQuestionContent.bind( this );
		this.handleSaveSettings = this.handleSaveSettings.bind( this );
	}

	/**
	 * Listener when we update the question content
	 *
	 * @param {string} value
	 */
	handleQuestionContent( value ) {
		if ( this._isMounted ) {
			this.setState( {
				content: value,
			} );
		}
	}

	/**
	 * Listener when saving the settings
	 *
	 * @param {handleSaveSettings} e
	 */
	async handleSaveSettings( e ) {
		e.preventDefault();

		const { content } = this.state;
		const { updateQuestionType, question } = this.props;

		const res = await updateQuestion( question.ID, {
			_question: content,
		} );

		if ( 200 === res ) {
			updateQuestionType( { ...question, post_content: content } );
			this.props.handleQuestionForm();
		}
	}

	/**
	 * When component is mounted
	 */
	componentDidMount() {
		this._isMounted = true;
	}

	/**
	 * When component is unmounted
	 */
	componentWillUnmount() {
		this._isMounted = false;
	}

	/**
	 * Render the Question Settings
	 *
	 * @event handleSaveSettings
	 */
	render() {
		const {
			question,
			data,
			editQuestionForm,
			handleQuestionForm,
		} = this.props;
		const { content, is_loading, error } = this.state;

		return (
			<div
				className={ `ld__builder--question-content ${
					editQuestionForm ? '-editing' : ''
				}` }
			>
				{ ! editQuestionForm && (
					<button
						className="ld__builder--edit-content ld-button-reset"
						onClick={ handleQuestionForm }
					>
						<span>{ data.labels.question }: </span>
						{ '' === content ? (
							<div className="ld__builder--edit-content-value">
								<div className="warning-icon -question">
									<Icon icon="warning" />
								</div>{ ' ' }
								<span className="warning">{ `${ LearnDashData.i18n.question_empty_edit }` }</span>
							</div>
						) : (
							<div
								className="ld__builder--edit-content-value"
								dangerouslySetInnerHTML={ { __html: content } }
							/>
						) }
						<Icon icon="pencil" />
						<span className="screen-reader-text">{ `${ LearnDashData.i18n.edit }` }</span>
					</button>
				) }

				{ editQuestionForm && (
					<Fragment>
						<RichText
							id={ `text-area-question-content-${ question.ID }` }
							value={ content }
							onChange={ this.handleQuestionContent }
						/>

						<div className="ld__builder--settings-actions">
							<button
								className="is-primary"
								onClick={ this.handleSaveSettings }
							>{ `${ LearnDashData.i18n.save }` }</button>
							<button
								className="is-default"
								onClick={ handleQuestionForm }
							>{ `${ LearnDashData.i18n.cancel }` }</button>

							{ is_loading && (
								<span className="ld__builder--form-notice">{ `${ LearnDashData.i18n.please_wait }` }</span>
							) }
							{ error && (
								<span className="ld__builder--form-error">
									{ error }
								</span>
							) }
						</div>
					</Fragment>
				) }
				<hr />
			</div>
		);
	}
}

/**
 * Valid props
 */
QuestionContent.propTypes = {
	editQuestionForm: PropTypes.bool,
	question: PropTypes.object,
	updateQuestionType: PropTypes.func,
	handleQuestionForm: PropTypes.func,
	lockQuestion: PropTypes.func,
	unlockQuestion: PropTypes.func,
	data: PropTypes.shape( {
		labels: PropTypes.object,
	} ),
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => ( {
	...state,
} );

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = ( dispatch ) => ( {
	updateQuestionType: ( node ) => dispatch( updateQuestionType( node ) ),
} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( QuestionContent );
